import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import MultiSelectSearchDropdown from "../component/MulteSelectSearch";
import { Form } from "react-bootstrap";
import { optionsSalary } from "../constant/optionSalary";
import { expOptions } from "../constant/exprienceOpttion";
import { educationOptions } from "../constant/educationOpt";
import { ApiConfig } from "../Api/ApiConfig";
import { simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { toastMsg } from "../component/toast";
import { simpleGetCall } from "../Api/ApiServices";


const ScreeningCondition = ({
  screeningCondition,
  setScreeningCondition,
  customQuestions,
  industries,
  setIsAiChatScreening,
  isAiChatScreening
}) => {


  const [educationAreas,setEducationsReas] = useState([])


  const getAllspecialization = () => {
          simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
              .then((res) => {
                  if (res.succeded) {
                      setEducationsReas(res?.response);
                  }
              })
  
      };

      useEffect(()=>{
        getAllspecialization()
      },[])


  const handleValuesChange = (key,subKey,values) => {
    console.log(screeningCondition);
    setScreeningCondition((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [subKey]: values,
      },
    }));
  }


    const tableData = [
        {
          type: "searchSelect",
          label: "Salary",
          options: optionsSalary,
          objKey:'salaryAlignment',
          value:screeningCondition?.salaryAlignment?.values,
          labelKey:'label',
          valueKey:'value'
        },
        {
          type: "date",
          label: "Available Before",
          objKey:'availability',
          value:screeningCondition?.availability?.values,
          options: '',
          labelKey:'label',
          valueKey:'value'
        },
        // {
        //     type: "searchSelect",
        //     label: "Relevant Experience",
        //     objKey:'relevantExperience',
        //     options: expOptions,
        //     value:screeningCondition?.relevantExperience?.values,
        //     labelKey:'label',
        //     valueKey:'value'
        //   },
        {
          type: "searchSelect",
          label: "Total Experience",
          options: expOptions,
          objKey:'totalExperience',
          value:screeningCondition?.totalExperience?.values,
          labelKey:'label',
          valueKey:'value'
        },
        
        {
          type: "searchSelect",
          label: "Industry Background",
          options: industries,
          objKey:'industryBackground',
          value:screeningCondition?.industryBackground?.values,
          labelKey:'label',
          valueKey:'value'
        },
        {
          type: "searchSelect",
          label: "Education Area",
          objKey:'educationArea',
          options: educationAreas,
          value:screeningCondition?.educationArea?.values,
          labelKey:'specializationName',
          valueKey:'specializationName'
        },
        {
          type: "searchSelect",
          label: "Custom Question 1",
          options: customQuestions,
          objKey:'customQuestion1',
          max:1,
          value:screeningCondition?.customQuestion1?.values,
          labelKey:'label',
          valueKey:'value',
          isMulti:false
        },
        {
          type: "searchSelect",
          label: "Custom Question 2",
          options: customQuestions,
          objKey:'customQuestion2',
          max:1,
          value:screeningCondition?.customQuestion2?.values,
          labelKey:'label',
          valueKey:'value',
          isMulti:false
        },
      ];

      const criticalSeleted = useMemo(()=>{


        let keys = Object.keys(screeningCondition)

        return keys.filter((i)=>{
          return screeningCondition[i]?.isCritical
        }).length
        

      },[screeningCondition])

      


  return (
    <>
    <div className="criteria-table-wrapper">
      <table className="criteria-table">
        <thead>
          <tr>
            <th>
            <Form.Label className="job_size">CONDITION TYPE</Form.Label>
                </th>
            <th>
            <Form.Label className="job_size">ACCEPTANCE CRITERION</Form.Label>
            </th>
            <th className="critical-col">
            <Form.Label className="job_size">CRITICAL (MAX 2)</Form.Label>
            </th>
          </tr>
        </thead>

        <tbody>
          {tableData.map((item, index) => (
            <tr key={index}>
              <td className="condition">

              <Form.Label className="job_size">{item?.label}</Form.Label>
            </td>

              <td>
                {
                    item?.type === 'date' && (
                        <div className="d-flex  align-items-center gap-2">

              <Form.Control
                            type="date"
                            style={{ width: "290px" }}
                            value={item?.value?item?.value[0] || '':""}
                            onChange={(e) =>{
                              if(!e.target.value){

                                 handleValuesChange(item?.objKey,'isCritical',false)
                                 
                              }
                              handleValuesChange(item?.objKey,'values',e.target.value?[e.target.value]:[])}}
                            className="input-text-14 font-size-h4"
                            
                          />
                        </div>
                    )
                }
                {
                  item?.type === 'listOption' && (
                    <>
                   
                    {
                      item?.options?.map((option,index)=>(
                        <div style={{ display: "flex", alignItems: "center", gap: "8px",border:'1px solid #e5e7eb',padding:'6px',borderRadius:'4px',marginBottom:'6px',fontSize:'14px',width:"700px" }}
                        onClick={()=>{
 

                          //  if(item?.value?.includes(option?.value)){
                          //   handleValuesChange(item?.objKey,'values',item?.value?.filter((v)=>v!=option?.value))
                          //   return
                          // }

                          handleValuesChange(item?.objKey,'values',[option?.value])  

                        }}
                        >
                          <input type="radio" 
                          checked={item?.value?.includes(option?.value)}
                          />
                          <p style={{ margin: 0 }}>{option?.label}</p>
                        </div>
                      )
                    )
                    }
                    </>
                  )
                }
                {
                    item?.type === 'searchSelect' && (
                      <div className="dropdown-wrapper">
                        {
                          console.log(item?.value)
                          
                        }
<MultiSelectSearchDropdown 
                options={item?.options}
                labelKey={item?.labelKey}
                valKey={item?.valueKey}
                value={item?.value}
                isMulti={item?.isMulti}
                handleValuesChange={(values)=>{

                  if(item?.max&& values.length>item?.max){

                    toastMsg('error',`only ${item.max} values are alllowed`)

                    return

                  }

                   if (item?.objKey === 'customQuestion1' || item?.objKey === 'customQuestion2') {
            const otherKey = item?.objKey === 'customQuestion1' ? 'customQuestion2' : 'customQuestion1';
            const otherValue = screeningCondition?.[otherKey]?.values;

            if (otherValue && values.length > 0) {
              const selectedVal = values[values.length - 1]; 
              if (otherValue.includes(selectedVal)) {
                toastMsg('error', 'This question is already selected in the other custom question');
                return;
              } 
            }
          }

          

          if(values.length===0){
            
                  handleValuesChange(item?.objKey,'isCritical',false)
          }

          

                  handleValuesChange(item?.objKey,'values',values)
                }

                }
                />
                </div>
                    )
                }
                
              </td>
              <td className="critical-col">
                <div className="d-flex align-items-center gap-2">

                  <div style={{marginTop:'-10px'}}>
                  <label className="switch">
                    <input type="checkbox" />
                    <label className="custom-switch-wrap m-0">
                      <div className="position-relative d-flex align-items-center">
                        <input
                          type="checkbox"
                          // disabled={criticalSeleted>=2 &&!screeningCondition?.[item?.objKey]?.isCritical}
                          className="switch-input"
                          checked={screeningCondition?.[item?.objKey]?.isCritical || false}
                          onChange={(e)=>{
                            if(e.target.checked&& criticalSeleted>=2){

                              toastMsg('error','max 2 critical can select')

                              return
                            }


                            if((!item?.value || item?.value?.length===0) && e.target.checked){

                              toastMsg('error',"Please Add Some Values Before Enable!")

                              return
                            }
                            

                            console.log(item.value);
                            

                            handleValuesChange(item?.objKey,'isCritical',e.target.checked)}}
                        />
                        <span className="switch-slider"></span>
                      </div>
                    </label>
                  </label>
                  </div>
                </div>
              </td>
            </tr>
          ))}




        </tbody>
      </table>

      <p className="text-muted " style={{marginLeft:'5px'}}>{criticalSeleted} of 2 critical selected</p>

    </div>

    <div className="criteria-table-wrapper mt-3">
      <table className="criteria-table">
        <tbody>
          <tr className="">
            <td className="condition align-middle">
              <div className="d-flex align-items-center" style={{marginTop:'5px'}} >
                <Form.Label className="job_size m-0">Ai Chat Screening</Form.Label>
              </div>
            </td>
            <td></td>
            <td className="align-middle critical-col">
              <div className="d-flex align-items-center gap-2">
                <label className="custom-switch-wrap m-0">
                  <div className="position-relative d-flex align-items-center">
                    <input
                      type="checkbox"
                      onChange={(e)=>{
                        setIsAiChatScreening(e.target.checked)
                      }}
                      checked={isAiChatScreening}
                      className="switch-input"
                    />
                    <span className="switch-slider"></span>
                  </div>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </>
  );
};

export default ScreeningCondition;